import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface InstalledPortfolioCardThemeProps {
  isTerminated: boolean;
  productsLength: number;
  ratesBlockHeight: string;
  hasMultiProductsPortfolio: boolean;
  installedOnlyCard: boolean;
}

const styles: ComponentStylesProps<InstalledPortfolioCardThemeProps> = {
  productCard: ({ isTerminated, productsLength, installedOnlyCard }) => ({
    border: `0.1rem solid ${isTerminated ? colors.red[200] : colors.blue[300]}`,
    backgroundColor: isTerminated ? '#FFF9F9' : '#F9FBFF',
    borderRadius: '1.5rem',
    padding: productsLength === 1 ? '2rem' : '4rem 3rem 3rem',
    boxSizing: 'border-box',
    width: installedOnlyCard && productsLength === 1 ? '50%' : '100%',
    display: 'grid',
    gap: '1.5rem',
    position: 'relative',
  }),

  // for installed stage
  singleProductWrapper: ({ installedOnlyCard }) => ({
    display: 'grid',
    gridTemplateRows: installedOnlyCard ? `auto auto 1fr auto` : `0 auto 1fr auto`,
    gap: '1.5rem',
  }),
  productsList: () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
    gap: '2rem',
  }),
  multiProductWrapper: ({ isTerminated }) => ({
    display: 'grid',
    gap: '1.5rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '1.5rem',
    padding: '2rem',
    boxSizing: 'border-box',
    border: `0.1rem solid ${isTerminated ? colors.red[200] : colors.blue[300]}`,
    gridAutoRows: 'auto 1fr',
  }),
  productHeader: ({ productsLength, installedOnlyCard }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: productsLength === 1 ? 'flex-start' : 'center',
    marginLeft: productsLength === 1 ? '0rem' : '0.5rem',
    marginTop: installedOnlyCard ? '3.6rem' : '1rem',
  }),
  productLineTitle: ({ productsLength }) => ({
    marginBottom: productsLength === 1 && '1rem',
    marginTop: productsLength === 1 && 0,
  }),
  dateStatus: ({ productsLength }) => ({
    fontSize: '1.4rem',
    lineHeight: '2rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'right',
    display: 'flex',
    flexDirection: productsLength === 1 ? 'column' : 'row',
    '& span:not(:last-child)': {
      marginRight: productsLength > 1 && '0.5rem',
    },
    margin: {
      top: productsLength === 1 ? '0.2rem' : 0,
      bottom: 0,
      right: productsLength > 1 && '1rem',
    },
  }),
  productTitle: () => ({
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[900],
    margin: 0,
    letterSpacing: '0.02em',
    fontWeight: '400',
  }),
  singleProductPortfolioTitle: ({ isTerminated, installedOnlyCard }) => ({
    marginTop: installedOnlyCard ? '0' : '2rem',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${isTerminated ? colors.red[200] : colors.blue[300]}`,
  }),
  multiProductHeader: ({ isTerminated, installedOnlyCard }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: installedOnlyCard ? '0 0 2rem' : '2.5rem 0 2rem',
    marginBottom: '2rem',
    borderBottom: `0.1rem solid ${isTerminated ? colors.red[200] : colors.blue[300]}`,
  }),
  ratesItem: ({ isTerminated }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'center',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.02em',
    '& span:first-child': {
      overflowWrap: 'break-word',
      maxWidth: '20rem',
    },
    '& span:last-child': {
      fontWeight: 700,
      color: isTerminated ? colors.red[600] : colors.blue[600],
    },
    '&:not(:last-child)': {
      marginBottom: '0.8rem',
    },
  }),
  downloadButton: {
    textTransform: 'uppercase',
    padding: 0,
    width: 'fit-content',
  },
  ratesContentWithButton: ({ isTerminated }) => ({
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${isTerminated ? colors.red[200] : colors.blue[300]}`,
  }),
  ratesWrapper: ({ productsLength, ratesBlockHeight }) => ({
    minHeight: productsLength === 1 ? ratesBlockHeight : 'auto',
  }),
  ratesTitle: () => ({
    font: { size: '1.4rem', lineHeight: '2rem' },
    fontWeight: 700,
    letterSpacing: '0.02em',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '1.5rem',
  }),
  ratesList: {
    maxWidth: '24rem',
    padding: '0',
    margin: 0,
  },
  ratesMessage: {
    fontSize: '1.4rem',
    color: colors.neutral[900],
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '1rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
